// src/App.tsx
import { Providers } from "./providers/providers";
import { WidgetPage } from "./widget-page";
import { parseWidgetConfig } from "../widget-config";
import { isMaintenanceMode, MaintenancePage } from "./maintenance-page";

function App() {
  // Passe par le schema partage plutot que de relire le parametre a la main :
  // c'est lui qui decrit ce que `embed.js` envoie, et il porte le defaut.
  const parsed = parseWidgetConfig(window.location.search);
  // Une URL malformee ne doit pas laisser une page blanche sur le site d'un
  // studio : on retombe sur le francais et on laisse le widget se debrouiller
  // avec ce qu'il trouve.
  const locale = parsed.ok ? parsed.config.locale : "fr";

  if (isMaintenanceMode()) {
    return <MaintenancePage locale={locale} />;
  }

  return (
    <Providers locale={locale}>
      <WidgetPage />
    </Providers>
  );
}

export default App;
